import React from 'react'
import { Card, CardItem} from '../../../../../../../../components/Card'

const InfoCards = ({ infoCards }) => {
    return (
        infoCards.map(({ title, info }) => (
            <Card
                key={info}
            >
                <CardItem
                    left={{
                        name: title,
                        value: info
                    }}
                />
            </Card>
        ))
    )
}

export default InfoCards
